import { render, staticRenderFns } from "./jinkoushangForm.vue?vue&type=template&id=ad1a8c7e&scoped=true&"
import script from "./jinkoushangForm.vue?vue&type=script&lang=js&"
export * from "./jinkoushangForm.vue?vue&type=script&lang=js&"
import style0 from "./jinkoushangForm.vue?vue&type=style&index=0&id=ad1a8c7e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1a8c7e",
  null
  
)

export default component.exports